import * as THREE from 'three';
import { stdMat } from './scene';
/* ============================================================
   機體材質（1:1 移植 `mech_sample_ani.html` §2）
   ============================================================

   放在 render/ 而不是 entities/ 的理由：原本 MAT_P 住在 `entities/mechs.ts`，
   而 `mech-kit.ts` 又要 import 它 —— mechs → kit → mechs 是一個循環。
   三層骨架把 `mechs.ts` 變成純組裝之後這個循環會更難拆，所以先切出來。

   `metalness` 不拉到 1.0：沒有環境貼圖時全金屬會讓陰影面死黑。
   `flatShading: true` 是所有技法裡投報率最高的一行。 */
export var MAT_P = {
  armor: stdMat(0x8794a8, { metal: 0.55, rough: 0.40, flat: true }),
  dark: stdMat(0x252d3d, { metal: 0.60, rough: 0.52, flat: true }),
  trim: stdMat(0x0e131f, { metal: 0.40, rough: 0.62, flat: true }),
  /* ⭐ 面罩是綠的（`05-ENEMY.md` §3 規則 3）。**整個遊戲裡綠色只會出現在你身上。**

     四色威脅語彙（紅接觸／橙直射／紫範圍／天藍支援）刻意不含綠 ——
     綠對幾乎所有人都讀作「安全／友方」，拿它當敵人的威脅色是在跟直覺打架。
     代價是原本的青 `0x5fe3ff` 要讓出來給支援型（天藍 `0x4f9dff`），
     兩者在 20px 下太接近，不能並存。

     這條是三條分辨規則裡最強的，因為 **emissive 是縮到 20px 之後
     最後才消失的東西**：剪影糊掉、明度被逆光吃掉的時候，
     「畫面上唯一的綠點就是我」還是成立。 */
  visor: glowMat(0x74ff9c, 2.2)
};

/** 發光材質。base 存進 `userData.base` —— **動畫層一律寫絕對值不做累加**，
    所以脈動、蓄力、排氣疊在一起也不會漂移。 */
function glowMat(hex, k) {
  var m = stdMat(0x0a0c11, { em: hex, ei: k, metal: 0, rough: 0.35, flat: true });
  m.userData.base = k;
  return m;
}

/* 核心決定**全機**的發光色相（設計文件 §7 / 決策 2）。

   遊戲鏡頭下機體只有約 60 像素高，18 個部件裡真正讀得到的只有
   「改剪影的那幾個」。剩下唯一還活著的通道是發光的**色相** ——
   而它不牴觸「亮的是你、暗的是裝備」，因為核心本來就是「你」。
   反過來做（讓武器的線圈搶眼）會踩到支柱三。 */
export var GLOW = {
  'core-std': glowMat(0xffb454, 1.7),
  'core-crit': glowMat(0xc46bff, 1.8),
  'core-burn': glowMat(0xff4a2c, 1.9)
};
export function coreGlow(coreShape) { return GLOW[coreShape] || GLOW['core-std']; }
